// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"117":"976920db","853":"fd8696cb","872":"a5453b2b","881":"3073b98b"}[chunkId] + ".chunk.css";
};